import React, { useRef } from 'react';
import { noop } from 'lodash';
import { MAP_API_KEYS } from '../../consts';
import MapPin from './MapPin';
import GoogleMapReact from 'google-map-react';
var PinIcon = function () { return (React.createElement("div", { style: { transform: 'translateY(-50%)', height: '32px' } },
    React.createElement(MapPin, null))); };
var MapContainer = function (_a) {
    var lat = _a.lat, lng = _a.lng, _b = _a.onClick, onClick = _b === void 0 ? noop : _b, isClickable = _a.isClickable;
    var mapRef = useRef(null);
    var mapOptions = {
        zoomControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        draggable: false,
        mapTypeId: 'satellite',
        draggableCursor: isClickable ? 'pointer' : '',
    };
    var apiKey = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
        ? MAP_API_KEYS['development']
        : MAP_API_KEYS['non-development'];
    return (React.createElement("div", { ref: mapRef, style: { height: '106px', width: '100%', marginTop: '12px' } },
        React.createElement(GoogleMapReact, { bootstrapURLKeys: { key: apiKey }, center: { lat: lat, lng: lng }, defaultZoom: 18, options: mapOptions, onClick: onClick },
            React.createElement(PinIcon, { lat: lat, lng: lng }))));
};
export default MapContainer;
